export default "__VITE_ASSET__oMQDW_f4__"